import { render, staticRenderFns } from "./auctionTimeCard.vue?vue&type=template&id=a54949f4&scoped=true"
import script from "./auctionTimeCard.vue?vue&type=script&lang=ts"
export * from "./auctionTimeCard.vue?vue&type=script&lang=ts"
import style0 from "./auctionTimeCard.vue?vue&type=style&index=0&id=a54949f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a54949f4",
  null
  
)

export default component.exports